export const text = (htmlString) => {
  const wrapper = document.createElement('div');

  wrapper.innerHTML = htmlString;

  return wrapper.textContent;
};

export const stepList = (steps) => {
  if (!Array.isArray(steps)) {
    return [];
  }

  return steps.map((step) => {
    step.sanitized_title = text(step.title);
    return step;
  });
};



/** WEBPACK FOOTER **
 ** ./src/helpers/htmlSanitize/index.js
 **/